<div class="overview">
	<div class="overview-header">
		<H2>Photo ID</H2>
		<span class="overview-sub-header">Verification of patient identity</span>
	</div>
	<button mat-stroked-button (click)="savePatient()">Save</button>
</div>

<div class="overview">
	<div class="overview-header">
		<H2>ID capture</H2>
		<div class="id-captures">
			<div class="id-div">
				<app-image-upload [label]="'Front of ID'" [imageSrc]="imageSrcFront" [target]="patientInfo.data" [field]="SurveyQuestions.SrcFront"></app-image-upload>
			</div>
			<div class="id-div">
				<app-image-upload [label]="'Back of ID'" [imageSrc]="imageSrcBack" [target]="patientInfo.data" [field]="SurveyQuestions.SrcBack"></app-image-upload>
			</div>
		</div>
	</div>
</div>

<div class="overview">
	<div class="tasks">
		<div>
			<div class="line-item">
				<a class="complete-all" (click)="completeAll()">Complete All</a>
			</div>
			@for (task of controller.id.items; track task) {
				<div class="line-item">
					<div>{{ task.label }}</div>
					<mat-checkbox [(ngModel)]="taskValues[controller.id.id +'.'+task.id]"
					              (ngModelChange)="setValue(controller.id.id,task.id,$event)"></mat-checkbox>
				</div>
			}
		</div>
	</div>
</div>
